import { Typography } from '@mui/material'
import AdminMainContainer from '../../../layouts/admin/AdminMainContainer'
import authStore from '../../../store/authStore'

export default function AdminDashboardPage() {
  const user = authStore(state => state.user)

  return (
    <AdminMainContainer title='Dashboard'>
      <Typography variant='h4'>{'Welcome,'}</Typography>
      <Typography variant='h5' color='primary.main'>
        {user?.displayName ?? user?.email}!
      </Typography>
    </AdminMainContainer>
  )
}
